import React, { useState, useCallback } from 'react';
import { Input, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const { Title } = Typography;

const WorkflowNameHeader = ({ 
  initialName = '', 
  isEditMode = false, 
  onNameChange 
}) => {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(initialName);

  React.useEffect(() => {
    setName(initialName);
  }, [initialName]);

  const handleStartEditing = () => {
    setEditing(true);
  };

  const handleNameChange = useCallback((e) => {
    setName(e.target.value);
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      setEditing(false);
      if (name !== initialName) {
        onNameChange(name);
      }
    }
  }, [name, initialName, onNameChange]);

  const handleBlur = useCallback(() => {
    setEditing(false);
    if (name !== initialName) {
      onNameChange(name);
    }
  }, [name, initialName, onNameChange]);

  const containerStyle = {
    position: 'absolute',
    top: '16px',
    left: '16px', 
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '8px',
    padding: '8px 16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    backdropFilter: 'blur(8px)',
    border: '1px solid rgba(0, 0, 0, 0.06)',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.2s ease',
    maxWidth: '400px',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    }
  };

  if (editing) {
    return (
      <div style={containerStyle}>
        <Input
          value={name}
          onChange={handleNameChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          placeholder="Enter workflow name"
          autoFocus
          style={{ 
            fontSize: '14px',
            fontWeight: 500,
            border: 'none',
            padding: '0px',
            backgroundColor: 'transparent',
            width: '300px',
            boxShadow: 'none',
            '&:focus': {
              boxShadow: 'none'
            }
          }}
        />
      </div>
    );
  }

  return (
    <div 
      onClick={handleStartEditing}
      style={{
        ...containerStyle,
        cursor: 'pointer',
      }}
    >
      <Title 
        level={5} 
        style={{ 
          margin: 0, 
          marginRight: '8px',
          fontSize: '14px',
          fontWeight: 500,
          color: '#1f1f1f',
          lineHeight: '1.4'
        }}
      >
        {name || 'Untitled Workflow'}
      </Title>
      <EditOutlined 
        style={{ 
          color: '#8c8c8c', 
          fontSize: '12px',
          opacity: 0,
          transition: 'opacity 0.2s ease'
        }} 
        className="edit-icon"
      />
      <style jsx>{`
        div:hover .edit-icon {
          opacity: 1;
        }
      `}</style>
    </div>
  );
};

export default WorkflowNameHeader;